import { useRouter } from 'next/router';

export const useSegmentContext = (): string => {
    const router = useRouter();
    return router.asPath.startsWith('/erhverv') ? 'business' : 'private';
};
